export const mutations = {
  setActivePageId(state, payload) {
    state.idActivePage = payload;
  },

  setPrologueUniVueComponentInfoBlockData(state, payload) {
    let newValue = true;

    if(!state.PrologueUniVueComponentInfoBlockData[payload.idPage]) {
      state.PrologueUniVueComponentInfoBlockData[payload.idPage] = [];

      state.PrologueUniVueComponentInfoBlockData[payload.idPage].push(payload);
    }

    state.PrologueUniVueComponentInfoBlockData[payload.idPage].forEach((el, i) => {

      if(payload.idBlock === el.idBlock && payload.nameElement === el.nameElement) {
        state.PrologueUniVueComponentInfoBlockData[payload.idPage][i] = payload;

        newValue = false
      }
    });

    if(newValue) {
      state.PrologueUniVueComponentInfoBlockData[payload.idPage].push(payload);
    }
  }

};